export class DateTimeHelper {

    // Metodo per ottenere il timestamp ISO e rimuovere -:. caratteri
    static getCleanedIsoTimestamp(): string {
        const isoTimestamp = new Date().toISOString();
        return isoTimestamp.replace(/[-:.]/g, '');
    }

    static getDateOnlyString(value: string | number | Date): string {
        const date = new Date(value);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const isoDate = `${yyyy}-${mm}-${dd}`; // "1900-01-10"
        return isoDate;
    }

}


